
// import "./element-variables.scss";
import Element, { ElConfigProvider } from "element-plus";
import locale from "element-plus/es/locale/lang/en";
import 'element-plus/dist/index.css'
import { defineComponent } from "vue";

export const OElConfigProvider = defineComponent((props, context) => {
  return () => (
    <ElConfigProvider {...props} locale={props.locale || locale}>
      {context.slots.default?.()}
    </ElConfigProvider>
  );
});

const useElement = (app) => {
  app.use(Element, {
    size: "small",
  });
};

export default useElement;
